import React, { useEffect, useState } from 'react'
import '../../App.scss'
import './ScenarioStages.scss'

const MacroReview = ({ periodNumber, periods }) => {
    const [description, setDescription] = useState(null)

    useEffect(() => {
        if (periods.length > 0)
            periods.map((p, index) => {
                if (periodNumber === (index + 1)) {
                    setDescription(p.macroeconomic_review.general_description)
                }
                return p
            })
    }, [periodNumber, periods])

    return (
        <div className="general_container stage_container">
            <h4 className="subtitle-stage">Macro Review</h4>
            {
                description &&
                <div>
                    <div dangerouslySetInnerHTML={{ __html: description }}></div>
                </div>

            }
        </div>
    )
}

export default MacroReview